module.exports = __webpack_public_path__ + "static/media/up_doodle.66b915f2.png";